		<template>
			<div v-if="visible" class="cookie">
				<div class="cookie-overlay"></div>
				<div class="cookie-banner">
					<!-- pulsante chiusura -->
					<MaoButton class="close-cookie" icon="close" status="text-button-opacity-light" aria-hidden
						@click="closeBanner" />
					<!-- testo banner -->
					<span class="cookie-banner-info">
						{{ bannerText }}
					</span>
					<!-- pulsanti -->
					<div class="cookie-banner-buttons">
						<MaoButton :label="declineLabel" status="primary" @click="decline" />
						<MaoButton :label="acceptLabel" status="primary" @click="accept" />
					</div>
				</div>
			</div>
		</template>

<script>
import { useAppDataStore } from '@/stores/appData';
import MaoButton           from './MaoButton.vue';

export default {
  name: 'CookieBanner',
  components: { MaoButton },

  data() {
    return {
      visible: false,
      appDataStore: useAppDataStore()
    };
  },

  computed: {
    bannerText() {
      return (
        this.appDataStore.appData.labels[
          'This website uses cookies to ensure you get the best experience on our website. By continuing to browse, you consent to the use of cookies.'
        ] || 'Questo sito utilizza cookie per offrirti la migliore esperienza.'
      );
    },
    acceptLabel() {
      return (
        this.appDataStore.appData.labels['Accept Cookies'] ||
        this.appDataStore.appData.labels['Accept'] ||
        'Accetta'
      );
    },
    declineLabel() {
      return (
        this.appDataStore.appData.labels['Decline Cookies'] ||
        this.appDataStore.appData.labels['Decline'] ||
        'Rifiuta'
      );
    }
  },

  mounted() {
    // Il plugin vue-gtm espone $gtm su this (vuoi averlo PRIMA di tutto)
    const stored = localStorage.getItem('cookie_consent');

    if (stored === 'granted') {
      this.enableTracking();
    } else if (stored === 'denied') {
      this.$gtm.enable(false);          // resta disattivato
    } else {
      this.visible = true;              // mostra banner
    }
  },

  methods: {
    /* ----- HELPERS ----------------------------------------------------- */
    enableTracking() {
      // ① aggiorna Consent Mode v2
      this.$gtm.trackEvent({
        event:              'consent_update',
        analytics_storage:  'granted',
        ad_storage:         'granted',
        ad_user_data:       'granted',
        ad_personalization: 'granted'
      });

      // ② abilita il firing dei tag
      this.$gtm.enable(true);
    },

    disableTracking() {
      this.$gtm.trackEvent({
        event:              'consent_update',
        analytics_storage:  'denied',
        ad_storage:         'denied',
        ad_user_data:       'denied',
        ad_personalization: 'denied'
      });

      this.$gtm.enable(false);
    },

    /* ----- ACTIONS ----------------------------------------------------- */
    accept() {
      localStorage.setItem('cookie_consent', 'granted');
      this.enableTracking();
      this.visible = false;
    },

    decline() {
      localStorage.setItem('cookie_consent', 'denied');
      this.disableTracking();
      this.visible = false;
    },

    closeBanner() {
      this.visible = false;
    }
  }
};
</script>
	<style scoped lang="scss">
	.cookie-overlay {
		position: fixed;
		inset: 0;
		background: rgba(0, 0, 0, .5);
		z-index: 1;
		pointer-events: none;
	}

	.cookie-banner {
		position: fixed;
		bottom: 0;
		width: 100%;
		z-index: 2;
		background: var(--surface-background-variant-dark);
		padding: 1rem;
		color: #fff;
		font-size: 1rem;

		@include breakpoint(s) {
			font-size: .8rem;
		}
	}

	.cookie-banner-buttons {
		display: flex;
		justify-content: flex-end;
		gap: 1rem;
		margin-top: 1rem;
	}

	.close-cookie {
		position: absolute;
		right: 0;
		top: -2rem;
	}
	</style>